const FilterByProp = {
  methods: {
    filterByProp(obj, prop, value, fallBackValue = null) {
      let objectByProp = obj.find((item) => item[prop] === value)
      if (objectByProp) {
        return objectByProp
      }

      objectByProp = obj.find((item) => item[prop] === fallBackValue)
      if (objectByProp) {
        return objectByProp
      }

      return value
    },
  },
}

export default FilterByProp
